/*
 * :file description:
 * :name: \yuhou\src\App.js
 * :author: xuhuajun
 * :copyright: (c) 2024, Tungee
 * :date created: 2024-01-24 17:17:44
 * :last editor: xuhuajun
 * :date last edited: 2024-03-19 14:31:46
 */
import { useState } from 'react';
import img1 from "./image/img1.jpg";
import img2 from "./image/img2.jpg";
import img3 from "./image/img3.jpg";
import img4 from "./image/img4.jpg";
import img5 from "./image/img5.jpg";
import img6 from "./image/img6.jpg";
import "./App.css";

function App() {
  const [activeLabel, setActiveLabel] = useState('home');
  const tabs = ['home', 'about', 'products']

  const goIcp = () => {
    window.open('https://beian.miit.gov.cn/#/Integrated/index')
  }

  const goBeian = () => {
    window.open('https://beian.mps.gov.cn/#/query/webSearch')
  }
  return (
    <div className="App">
      <div className="nav">
        {
          tabs.map(item => {
            return (<a className={activeLabel===item ? 'title activeTitle' : 'title'}  href={`#${item}`} onClick={() => {setActiveLabel(item)}}>{item.toUpperCase()}</a>)
          })
        }
      </div>

      <div className="home" id="home">
        <img src={img1} alt="" className="img"></img>
        <img src={img2} alt="" className="img"></img>
        <img src={img3} alt="" className="img"></img>
      </div>

      <div className="about" id="about">
        <div className="wrapper">
          <div className="title">About</div>
          <div className="text">
            Established in 1997, one of the most famous manufacturer, supplier
            and developer of casters and carts. We have a design and production
            team of over 170 people, and more than 20 years of experience in
            product development and production.
          </div>
        </div>
      </div>
      
      <div className="products" id="products">
        <div className="title">Special products</div>

        <div className="product-singular">
          <div className="image">
            <img alt="" src={img4}></img>
          </div>
          <div className="content">
            <h3 className="name">Washing machine stand</h3>
            <div className="desc">The European-style leather sofa affords you a completely new experience.</div>
          </div>
        </div>

        <div className="product-even">
          <div className="image">
            <img alt="" src={img5}></img>
          </div>
          <div className="content">
            <h3 className="name">Plant caddy with wheels</h3>
            <div className="desc">A sentence or two describing this item. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet.</div>
          </div>
        </div>

        <div className="product-singular">
          <div className="image">
            <img alt="" src={img6}></img>
          </div>
          <div className="content">
            <h3 className="name">Caster wheels heavy duty</h3>
            <div className="desc">A sentence or two describing this item. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet.</div>
          </div>
        </div>

      </div>

      {/* <div className="fixedImage"></div> */}

      <div className="footer">
        <p onClick={goBeian}>粤公网安备44010502002770号</p>
        <p onClick={goIcp}>粤ICP备2024199879号-1</p>
      </div>
    </div>
  );
}

export default App;
